import React from "react";
import FilterList from "../../../components/user/mermaPart/mermaPartFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const MermaPartListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

MermaPartListPage.propTypes = {};

export default MermaPartListPage;
